/**
 * UI가 바라보는 게임 세션 인터페이스.
 *
 * 온라인(Colyseus 룸)과 로컬(연습 / AI 대전)이 이 인터페이스를 똑같이 구현하므로
 * main.ts의 UI 코드는 둘을 구분하지 않는다. 로컬 모드도 서버와 **같은**
 * `@scb/rules` + `@scb/sim`을 쓰기 때문에 규칙이 갈라질 일이 없다.
 */

export type SessionMode = "online" | "practice" | "ai";

export interface PlayerView {
  sessionId: string;
  name: string;
  steamId: string;
  team: number;
  slot: number;
  connected: boolean;
  ready: boolean;
}

export interface BallView {
  id: number;
  team: number;
  x: number;
  y: number;
  state: string;
  astrolabe: number;
  slot: number;
}

export interface TeamView {
  score: number;
  ballsRemaining: number;
}

export interface BattleView {
  format: string;
  phase: string;
  round: number;
  phaseEndsAt: number;
  turnEndsAt: number;
  turnTeam: number;
  currentShooter: string;
  finalSequenceTeam: number;
  winner: number;
  teams: TeamView[];
  /** Colyseus MapSchema와 JS Map이 모두 만족하는 최소 형태 */
  players: { forEach(cb: (value: PlayerView, key: string) => void): void };
  balls: readonly BallView[];
}

export interface GameSession {
  readonly kind: SessionMode;
  readonly sessionId: string;
  readonly state: BattleView;
  send(type: string, payload?: unknown): void;
  onStateChange(cb: (state: BattleView) => void): void;
  onMessage<T>(type: string, cb: (msg: T) => void): void;
  leave(): Promise<void>;
}

export function playersOf(state: BattleView): PlayerView[] {
  const list: PlayerView[] = [];
  state.players?.forEach((p) => list.push(p));
  return list.sort((a, b) => a.team - b.team || a.slot - b.slot);
}

/** 로컬 연습 모드에서만 쓰는 메시지 (서버는 보내지 않는다). */
export const LOCAL_PRACTICE_SUMMARY = "practice_summary";

export interface PracticeSummary {
  shots: number;
  total: number;
  /** 한 샷 최고 점수 */
  best: number;
}
